export default __webpack_public_path__ + "static/media/sunhotel-banner.c61c85dd.jpg";